import {useEffect, useMemo, useState} from 'react';
import {API, graphqlOperation} from "aws-amplify";
const getAdminMortgageFiguresTest = /* GraphQL */`

    query GetAdminMortgageFiguresTest($id: ID!) {
        getAdminMortgageFiguresTest(id: $id) {
            id
            flowID
            mortgageID
            value
            loan
            term
            lenders
            variableUsed
            incomeUsed
            figures
            status
            verifiedFiguresUsed
            testName
            tests {
                items {
                    id
                    lenderCode
                    mortgageID
                    testID
                    loan
                    term
                    value
                    status
                    output
                    passed
                    fileUrl
                    exception
                    limitedBy
                    cashForLiving
                    maxLTV
                    bof
                    runtime
                    lti
                    createdAt
                    updatedAt
                    _version
                    _deleted
                    _lastChangedAt
                    __typename
                }
                nextToken
                startedAt
                __typename
            }
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
        }
    }
`;
const adminMortgageFiguresTestsByMortgageID = /* GraphQL */ `
    query AdminMortgageFiguresTestsByMortgageID(
        $mortgageID: ID!
        $sortDirection: ModelSortDirection
        $filter: ModelAdminMortgageFiguresTestFilterInput
        $limit: Int
        $nextToken: String
    ) {
        adminMortgageFiguresTestsByMortgageID(
            mortgageID: $mortgageID
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                flowID
                mortgageID
                value
                loan
                term
                lenders
                variableUsed
                incomeUsed
                figures
                status
                verifiedFiguresUsed
                testName
                tests {
                    items {
                        id
                        lenderCode
                        mortgageID
                        testID
                        loan
                        term
                        value
                        status
                        output
                        passed
                        fileUrl
                        limitedBy
                        cashForLiving
bof
                        createdAt
                        updatedAt
                        _version
                        _deleted
                        _lastChangedAt
                        __typename
                    }
                    nextToken
                    startedAt
                    __typename
                }
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
            }
            nextToken
            startedAt
            __typename
        }
    }
`;
const onCreateAdminMortgageFiguresTest = /* GraphQL */`

    subscription OnCreateAdminMortgageFiguresTest(
        $filter: ModelSubscriptionAdminMortgageFiguresTestFilterInput
    ) {
        onCreateAdminMortgageFiguresTest(filter: $filter) {
            id
            flowID
            mortgageID
            value
            loan
            term
            lenders
            variableUsed
            incomeUsed
            figures
            status
            verifiedFiguresUsed
            testName
            tests {
                items {
                    id
                    lenderCode
                    mortgageID
                    testID
                    test {
                        id
                        flowID
                        mortgageID
                        value
                        loan
                        term
                        lenders
                        variableUsed
                        incomeUsed
                        figures
                        status
                        verifiedFiguresUsed
                        testName
                        tests {
                            nextToken
                            startedAt
                            __typename
                        }
                        createdAt
                        updatedAt
                        _version
                        _deleted
                        _lastChangedAt
                        __typename
                    }
                    loan
                    term
                    value
                    status
                    output
                    passed
                    fileUrl
                    exception
                    limitedBy
                    cashForLiving
                    maxLTV
                    bof
                    runtime
                    lti
                    createdAt
                    updatedAt
                    _version
                    _deleted
                    _lastChangedAt
                    __typename
                }
                nextToken
                startedAt
                __typename
            }
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
        }
    }
`;
const onUpdateAdminMortgageFiguresTest = /* GraphQL */`

    subscription OnUpdateAdminMortgageFiguresTest(
        $filter: ModelSubscriptionAdminMortgageFiguresTestFilterInput
    ) {
        onUpdateAdminMortgageFiguresTest(filter: $filter) {
            id
            flowID
            mortgageID
            value
            loan
            term
            lenders
            variableUsed
            incomeUsed
            figures
            status
            verifiedFiguresUsed
            testName
            tests {
                items {
                    id
                    lenderCode
                    mortgageID
                    testID
                    test {
                        id
                        flowID
                        mortgageID
                        value
                        loan
                        term
                        lenders
                        variableUsed
                        incomeUsed
                        figures
                        status
                        verifiedFiguresUsed
                        testName
                        tests {
                            nextToken
                            startedAt
                            __typename
                        }
                        createdAt
                        updatedAt
                        _version
                        _deleted
                        _lastChangedAt
                        __typename
                    }
                    loan
                    term
                    value
                    status
                    output
                    passed
                    fileUrl
                    exception
                    limitedBy
                    cashForLiving
                    maxLTV
                    bof
                    runtime
                    lti
                    createdAt
                    updatedAt
                    _version
                    _deleted
                    _lastChangedAt
                    __typename
                }
                nextToken
                startedAt
                __typename
            }
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
        }
    }
`;


function useAdminMortgageTestForPass(mortgageID) {
    const [tests, setTests] = useState([])
    const [activeTestId, setActiveTestId] = useState(null)
    const [busy, setBusy] = useState(false)

    const loadFullTest = async (id) => {
        // Prevent duplicate loading if data already exists
        const active = tests.find(t => t.id === id)
        if (active?.fastTests?.items?.length > 0) {
            setActiveTestId(id)
            return
        }

        const {data} = await API.graphql(graphqlOperation(getAdminMortgageFiguresTest, {id}))
        setTests(s => {
            let existing = s.find(t => t.id === id)
            if (existing) {
                return s.map(t => t.id === id ? data.getAdminMortgageFiguresTest : t)
            }
            return [...s, data.getAdminMortgageFiguresTest]
        })
        setActiveTestId(id)
    }

    // Combine the test history loading and subscription setup into a single effect
    useEffect(() => {
        if (!mortgageID) return

        let subscriptions = []

        loadTestHistory()

        // Set up subscriptions
        subscriptions = [
            API.graphql(graphqlOperation(onCreateAdminMortgageFiguresTest)).subscribe({
                next: ({value}) => {
                    const newTest = value.data.onCreateAdminMortgageFiguresTest
                    if (newTest.mortgageID !== mortgageID) return
                    setTests(prev => [newTest, ...prev])
                    setActiveTestId(newTest.id)
                }
            }),
            API.graphql(graphqlOperation(onUpdateAdminMortgageFiguresTest)).subscribe({
                next: ({value}) => {
                    const update = value.data.onUpdateAdminMortgageFiguresTest
                    if (update.mortgageID !== mortgageID) return
                    setTests(s => s.map(t => t.id === update.id ? {...t, ...update} : t))
                    if (update.status === 'PROCESSED') setBusy(false)
                }
            })
        ]

        // Cleanup subscriptions
        return () => {
            subscriptions.forEach(sub => sub.unsubscribe())
        }
    }, [mortgageID])

    // Handle fast test subscriptions separately
    // useEffect(() => {
    //     if (!mortgageID) return
    //
    //     const subscriptions = [
    //         API.graphql(graphqlOperation(onCreateAdminMortgageFastTest)).subscribe({
    //             next: ({value}) => {
    //                 const newChild = value.data.onCreateAdminMortgageFastTest
    //                 if (newChild.mortgageID !== mortgageID) return
    //                 const testId = newChild.flowID
    //                 setTests(s => s.map(t => t.id === testId ? {
    //                     ...t,
    //                     fastTests: {
    //                         items: [...(t.fastTests?.items || []), newChild]
    //                     }
    //                 } : t))
    //             }
    //         }),
    //         API.graphql(graphqlOperation(onUpdateAdminMortgageFastTest)).subscribe({
    //             next: ({value}) => {
    //                 const updatedChild = value.data.onUpdateAdminMortgageFastTest
    //                 if (updatedChild.mortgageID !== mortgageID) return
    //                 const testId = updatedChild.flowID
    //                 setTests(s => s.map(t => t.id === testId ? {
    //                     ...t,
    //                     fastTests: {
    //                         items: t.fastTests.items.map(ft =>
    //                             ft.id === updatedChild.id ? {...ft, ...updatedChild} : ft
    //                         )
    //                     }
    //                 } : t))
    //             }
    //         })
    //     ]
    //
    //     return () => {
    //         subscriptions.forEach(sub => sub.unsubscribe())
    //     }
    // }, [mortgageID])

    const activeTest = useMemo(() => {
        return tests.find(t => t.id === activeTestId)
    }, [tests, activeTestId])
    const loadTestHistory = async () => {
        if (!mortgageID) return
        API.graphql(graphqlOperation(adminMortgageFiguresTestsByMortgageID, {mortgageID}))
            .then(({data}) => {
                const sorted = data.adminMortgageFiguresTestsByMortgageID.items.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
                setTests(sorted)
                if (sorted[0]) loadFullTest(sorted[0].id)
            })
    }
    const refreshTestHistory = async () => {
        setActiveTestId(null)
        setTests([])
        await loadTestHistory()
    }

    return {tests, activeTest, loadTest: loadFullTest, refreshTestHistory, busy, setBusy}
}

export default useAdminMortgageTestForPass;